"use client";

import { useState } from "react";
import { Send } from "lucide-react";

export type ChatInputProps = {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
};

export default function ChatInput({ value, onChange, onSend }: ChatInputProps) {
  const [isComposing, setIsComposing] = useState(false);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !isComposing) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <div className="border-t border-[#e99bad]/10 p-3">
      <div className="relative">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          onCompositionStart={() => setIsComposing(true)}
          onCompositionEnd={() => setIsComposing(false)}
          placeholder="メッセージを入力..."
          className="w-full rounded-full bg-slate-100 py-2.5 pl-4 pr-12 text-sm outline-none focus:ring-2 focus:ring-[#e99bad]/30"
        />
        <button
          onClick={onSend}
          className="absolute right-1.5 top-1/2 -translate-y-1/2 w-9 h-9 bg-[#e99bad] rounded-full flex items-center justify-center hover:bg-[#e99bad]/90 transition-colors"
        >
          <Send className="w-4 h-4 text-white" />
        </button>
      </div>
    </div>
  );
}
